module.exports = __webpack_public_path__ + "static/media/010.591fddf4.jpg";